import PropTypes from 'prop-types'
import {
  branch,
  compose,
  getContext,
  renderNothing,
  withProps,
  withStateHandlers,
} from 'recompose'
import noop from 'lodash/noop'
import { sampleLoan } from '../../../../constants/homePreview'
import selectInterestAndPrincipalData from '../selectInterestAndPrincipalData'

const contextTypes = {
  withCurrentHomeData: PropTypes.bool.isRequired,
}

const composeWithHomeData = compose(
  selectInterestAndPrincipalData,
  branch(
    ({ shouldCheckNumbers, emptyState }) => emptyState && !shouldCheckNumbers,
    renderNothing
  )
)

const composeWithoutHomeData = compose(
  withProps(() => {
    const {
      principalPaid: principal,
      principalDiff,
      interestPaid: interest,
    } = sampleLoan.progress
    const total = principal + interest

    return {
      shouldCheckNumbers: false,
      unverifiedLoans: [],
      loans: [sampleLoan],
      principal: Math.round(principal),
      principalDiff,
      principalRatio: principal / total,
      interest: Math.round(interest),
      interestRatio: interest / total,
      openLoans: noop,
      confirmLoanEstimates: noop,
    }
  })
)

const PaidSoFarContainer = compose(
  getContext(contextTypes),
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  ),
  withStateHandlers(
    { expandCheckSection: false },
    {
      setExpandCheckSection: () => expandCheckSection => ({
        expandCheckSection,
      }),
      expand:
        ({ expandCheckSection }, { shouldCheckNumbers }) =>
        () => {
          if (expandCheckSection || !shouldCheckNumbers) {
            return {}
          }

          return { expandCheckSection: true }
        },
    }
  ),
  withProps(
    ({ confirmLoanEstimates, setExpandCheckSection, unverifiedLoans }) => ({
      markLoans: () => {
        confirmLoanEstimates(unverifiedLoans)
        setExpandCheckSection(false)
      },
    })
  )
)

export default PaidSoFarContainer
